import React, { useEffect, useMemo, useState } from "react";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake";
import {
  ektipotikoAitisis,
  sinoptikoEktipotiko,
} from "../../../printHtmlfiles/sinoptikoEktipotiko";
import { fetchPrfcsForExternalUser } from "../../../services/prfcsService";
import { useQuery } from "react-query";
import useLocale from "../../../hooks/useLocale";
import { Button, Grid, Typography } from "@material-ui/core";
import styled from "styled-components/macro";
import { fetchApplicationHistory } from "../../../services/applicationsHistory";
import { FINISHED } from "../../../constants";
import dayjs from "dayjs";
import CustomAlert from "../../components/CustomAlert";
import { Alert } from "@material-ui/lab";
import GovGrButton from "../../../components/GovGrButton";

function PrintApplicationDetails({ data, id }) {
  const { t } = useLocale();
  const [applicationFinishedStatus, setApplicationFinishedStatus] =
    useState(false);
  const { data: applicationHistory } = useQuery(
    ["applicationHistoryWithId", id],
    () => fetchApplicationHistory(id)
  );
  const { data: prfcsData } = useQuery("prfcs", fetchPrfcsForExternalUser);

  // Get the info if application is finished
  const isApplicationFinished = applicationHistory?.find(
    (status) => status.new_status === FINISHED
  );

  // Date that Application was finished
  const applicationFinishedDate = dayjs(
    isApplicationFinished?.change_dt
  ).format("DD/MM/YYYY");

  useEffect(() => {
    !isApplicationFinished
      ? setApplicationFinishedStatus(false)
      : setApplicationFinishedStatus(true);
  }, [isApplicationFinished]);

  // Get dscr of the birth_place_afora Id
  const birthPlace = useMemo(() => {
    return prfcsData?.find((place) => place.id === data?.place_birth_afora);
  }, [prfcsData, data]);

  //Get html for Sinoptiko Ektipotiko
  const htmlForPdfDataSinoptiko = sinoptikoEktipotiko(
    data,
    birthPlace?.dscr,
    applicationFinishedDate
  );

  //Get html for Ektipotiko Aitisis
  const htmlForPdfDataEktipotikoAitisis = ektipotikoAitisis(
    data,
    birthPlace?.dscr,
    applicationFinishedDate
  );

  // Function that creates data from HTML
  const createPdfFromHtml = async (data) => {
    var html = htmlToPdfmake(data);
    const documentDefinition = {
      info: {
        title: data?.reg_num,
      },
      content: html,
      pageMargins: [5, 10, 5, 10],
      defaultStyle: {
        font: "Roboto",
      },
    };
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.createPdf(documentDefinition).print();
  };

  return (
    <StyledGridContainer container spacing={6} direction="column">
      <StyledGridItem item>
        <BoxWrapper>
          <Typography variant="h3">
            {t("Brief Summary of Application")}
          </Typography>
          <StyledTypography variant="h6">
            {t(
              "You can print a brief summary of the application of the Sailor"
            )}
          </StyledTypography>
          {!applicationFinishedStatus && (
            <Alert severity="error" style={{ marginBottom: "1rem" }}>
              {t(
                "Application hasn't been finished,so you can't print the summary"
              )}
            </Alert>
          )}
          <GovGrButton
            variant="contained"
            color="primary"
            onClick={() => createPdfFromHtml(htmlForPdfDataSinoptiko)}
            disabled={!applicationFinishedStatus ? true : false}
            buttonText={t("Print")}
          />
        </BoxWrapper>
      </StyledGridItem>
      <StyledGridItem item>
        <BoxWrapper>
          <Typography variant="h3">
            {t("Print all application details")}
          </Typography>
          <StyledTypography variant="h5">
            {t(
              "You can print a summary of the application details of the Sailor"
            )}
          </StyledTypography>
          {!applicationFinishedStatus && (
            <Alert severity="error" style={{ marginBottom: "1rem" }}>
              {t(
                "Application hasn't been finished,so you can't print the summary"
              )}
            </Alert>
          )}
          <GovGrButton
            variant="contained"
            color="primary"
            onClick={() => createPdfFromHtml(htmlForPdfDataEktipotikoAitisis)}
            disabled={!applicationFinishedStatus ? true : false}
            buttonText={t("Print")}
          />
        </BoxWrapper>
      </StyledGridItem>
    </StyledGridContainer>
  );
}

const StyledGridContainer = styled(Grid)`
  padding: 5rem;
`;

const StyledGridItem = styled(Grid)`
  display: flex;
  /* justify-content: center; */
  height: 20%;
  flex-direction: column;
`;

const BoxWrapper = styled("div")`
  width: 50%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const StyledTypography = styled(Typography)`
  margin: 2rem 0;
`;
export default PrintApplicationDetails;
